<template>
  <div class="refuse">
    <div class="refuse__wrap">
      <div class="refuse__content">
        <div class="refuse__question" v-if="!refuse_sent">
          <div class="refuse__title refuse__title_top">
            {{ $tr('vacancy.preferences.refuse.question') }}
          </div>
          <div class="refuse__text">
            {{ $tr('vacancy.preferences.refuse.choose') }}
          </div>
          <div class="refuse__select">
            <multiselect
              open-direction="bottom"
              track-by="id"
              label="reason"
              class="w"
              v-model="selected"
              :options="list"
              :show-labels="false"
              :allow-empty="true"
              :searchable="false"
            />
          </div>
          <div class="refuse__btn">
            <vbutton
              label="vacancy.preferences.refuse.button"
              :loading="loading"
              @click="sent_refuse"
            />
          </div>
        </div>

        <div class="refuse__answer" v-if="refuse_sent">
          <img src="/static/images/elements/icon_ok.png" />
          <div class="refuse__title refuse__title_bottom">
            {{ $tr('vacancy.preferences.refuse.answer') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'refuse-interview',

    props: ['token'],

    data() {
      return {
        refuse_sent: false
      };
    },

    created() {
      this.$store.commit('interview/refuse/set_token', this.token);
      this.$store.dispatch('interview/refuse/load', this.token);
    },

    computed: {
      list() {
        return this.$store.getters['interview/refuse/list'];
      },

      selected: {
        get() {
          return this.$store.getters['interview/refuse/selected'];
        },
        set(val) {
          this.$store.commit('interview/refuse/set_selected', val);
        }
      },

      loading() {
        return this.$store.getters['interview/refuse/loaded'];
      }
    },

    methods: {
      sent_refuse() {
        this.$store
          .dispatch('interview/refuse/sent', {
            id: this.selected.id,
            description: ''
          })
          .then(() => {
            this.refuse_sent = true;
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .refuse {
    position: relative;
    min-height: calc(100vh - 90px);
    display: flex;
    align-items: center;
    justify-content: center;

    &__wrap {
      width: 800px;
      height: 542px;
      background: #ffffff;
      box-shadow: 0px 1px 40px rgba(28, 50, 75, 0.05);
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__content {
      max-width: 500px;
      color: #233346;
      text-align: center;
    }

    &__title {
      font-style: normal;
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;

      &_top {
        max-width: 280px;
      }

      &_bottom {
        max-width: 450px;
        margin-top: 20px;
      }
    }

    &__text {
      font-size: 15px;
      margin: 14px 0 24px;
    }

    &__select .multiselect {
      width: 280px;
      max-width: 280px;
      margin: 0 auto;
    }

    &__btn {
      margin-top: 30px;
    }
  }
</style>
